<template>
    <div class="dizme_tm_section" id="portfolio">
        <div class="dizme_tm_portfolio">
            <div class="container">
                <div class="dizme_tm_main_title" style="margin-bottom: 50px !important" data-align="center">
                    <span>Portfolio</span>
                    <h3>My Design Works</h3>
                    <p>Explore my case studies and design system projects</p>
                </div>
                <div class="dizme_tm_portfolio_titles"></div>
                <div class="portfolio_list wow fadeInUp" data-wow-duration="1s">
                    <ul class="gallery_zoom grid">
                        <li class="popup grid-item" order="1">
                            <div class="inner">
                                <div
                                    class="entry dizme_tm_portfolio_animation_wrap"
                                    data-title="B2B Event Platform"
                                    data-category="On-Boarding Process"
                                >
                                    <a href="https://www.behance.net/gallery/213652757/Case-study-B2B-event-platform-registration" target="_blank">
                                        <img src="/img/thumbs/42-34.jpg" alt="" />
                                        <div class="main" data-img-url="/img/portfolio/6.jpg"></div>
                                    </a>
                                </div>
                                <div class="mobile_title">
                                    <h3>B2B Event Platform</h3>
                                    <span>On-Boarding Process</span>
                                </div>
                            </div>
                        </li>
                        <li class="vimeo grid-item" order="2">
                            <div class="inner">
                                <div class="entry dizme_tm_portfolio_animation_wrap" data-title="Parent Referral System" data-category="Landing Page">
                                    <a href="https://www.behance.net/gallery/153997551/Case-study-Parent-referral-program" target="_blank">
                                        <img src="/img/thumbs/42-34.jpg" alt="" />
                                        <div class="main" data-img-url="/img/portfolio/2.jpg"></div>
                                    </a>
                                </div>
                                <div class="mobile_title">
                                    <h3>Parent Referral System</h3>
                                    <span>Landing Page</span>
                                </div>
                            </div>
                        </li>
                        <li class="popup grid-item" order="3">
                            <div class="inner">
                                <div class="entry dizme_tm_portfolio_animation_wrap" data-title="Design System" data-category="Stencil">
                                    <a href="https://drive.google.com/file/d/1QZ_diYIYXPty8-atr5VYYsi_jl3CJgL6/view?usp=sharing" target="_blank">
                                        <img src="/img/thumbs/42-34.jpg" alt="" />
                                        <div class="main" data-img-url="/img/portfolio/4.jpg"></div>
                                    </a>
                                </div>
                                <div class="mobile_title">
                                    <h3>Design System</h3>
                                    <span>Stencil</span>
                                </div>
                            </div>
                        </li>
                        <li class="youtube grid-item" order="4">
                            <div class="inner">
                                <div class="entry dizme_tm_portfolio_animation_wrap" data-title="Career Mate" data-category="Mobile App">
                                    <a
                                        href="https://www.behance.net/gallery/133498023/Case-study-Career-counselling-and-guidance-app"
                                        target="_blank"
                                    >
                                        <img src="/img/thumbs/42-56.jpg" alt="" />
                                        <div class="main" data-img-url="/img/portfolio/1.jpg"></div>
                                    </a>
                                </div>
                                <div class="mobile_title">
                                    <h3>Career Mate</h3>
                                    <span>Mobile App</span>
                                </div>
                            </div>
                        </li>
                        <li class="popup grid-item" order="5">
                            <div class="inner">
                                <div
                                    class="entry dizme_tm_portfolio_animation_wrap"
                                    data-title="Leave Management System"
                                    data-category="Landing Page"
                                >
                                    <a
                                        href="https://medium.com/design-bootcamp/case-study-web-landing-page-for-leave-management-system-d404b302cda9"
                                        target="_blank"
                                    >
                                        <img src="/img/thumbs/42-56.jpg" alt="" />
                                        <div class="main" data-img-url="/img/portfolio/5.jpg"></div>
                                    </a>
                                </div>
                                <div class="mobile_title">
                                    <h3>Leave Management System</h3>
                                    <span>Landing Page</span>
                                </div>
                            </div>
                        </li>
                        <li class="soundcloud grid-item" order="6">
                            <div class="inner">
                                <div class="entry dizme_tm_portfolio_animation_wrap" data-title="Champions of Campk12" data-category="Landing Page">
                                    <a href="https://www.behance.net/gallery/204255793/Case-study-Landing-page" target="_blank">
                                        <img src="/img/thumbs/42-56.jpg" alt="" />
                                        <div class="main" data-img-url="/img/portfolio/3.jpg"></div>
                                    </a>
                                </div>
                                <div class="mobile_title">
                                    <h3>Champions of Campk12</h3>
                                    <span>Landing Page</span>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="brush_1 wow zoomIn" data-wow-duration="1s">
                <img src="/img/brushes/portfolio/1.png" alt="" />
            </div>
            <div class="brush_2 wow fadeInRight" data-wow-duration="1s">
                <img src="/img/brushes/portfolio/2.png" alt="" />
            </div>
        </div>
    </div>
    <!-- <MagnificPopUpVue
    :modal="modal"
    :close="closeModal"
    :name="name"
    :src="src"
  />
  <div :class="`${active === 1 ? '' : 'hidden_content'}`">
    <ModalBox :close="close">
      <div class="popup_details">
        <div class="top_image">
          <img src="img/thumbs/4-2.jpg" alt="" />
          <div
            class="main"
            data-img-url="img/portfolio/6.jpg"
            style="background-image: url('img/portfolio/6.jpg')"
          ></div>
        </div>
        <div class="portfolio_main_title">
          <h3>Global Evolution</h3>
          <span><a href="#">Detail</a></span>
          <div></div>
        </div>
        <div class="main_details">
          <div class="textbox">
            <p>
              We live in a world where we need to move quickly and iterate on
              our ideas as flexibly as possible.
            </p>
            <p>
              Mockups are useful both for the creative phase of the project -
              for instance when you're trying to figure out your user flows or
              the proper visual hierarchy - and the production phase when they
              phase when they will represent the target product. Building
              mockups strikes the ideal balance ease of modification.
            </p>
          </div>
          <div class="detailbox">
            <ul>
              <li>
                <span class="first">Client</span>
                <span>Alvaro Morata</span>
              </li>
              <li>
                <span class="first">Category</span>
                <span><a href="#">Detail</a></span>
              </li>
              <li>
                <span class="first">Date</span>
                <span>March 07, 2021</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="additional_images">
          <ul>
            <li>
              <div class="list_inner">
                <div class="my_image">
                  <img src="img/thumbs/4-2.jpg" alt="" />
                  <div
                    class="main"
                    data-img-url="img/portfolio/1.jpg"
                    style="background-image: url('img/portfolio/1.jpg')"
                  ></div>
                </div>
              </div>
            </li>
            <li>
              <div class="list_inner">
                <div class="my_image">
                  <img src="img/thumbs/4-2.jpg" alt="" />
                  <div
                    class="main"
                    data-img-url="img/portfolio/2.jpg"
                    style="background-image: url('img/portfolio/2.jpg')"
                  ></div>
                </div>
              </div>
            </li>
            <li>
              <div class="list_inner">
                <div class="my_image">
                  <img src="img/thumbs/4-2.jpg" alt="" />
                  <div
                    class="main"
                    data-img-url="img/portfolio/3.jpg"
                    style="background-image: url('img/portfolio/3.jpg')"
                  ></div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </ModalBox>
  </div> -->
</template>

<script>
// import MagnificPopUpVue from "./popup/MagnificPopUp.vue";
// import ModalBox from "./popup/ModalBox.vue";
export default {
    name: "PortfolioComponent",
    data() {
        return {
            activeNav: "1", // props
            name: "",
            src: "",
            modal: false,
            // Content
            active: 0,
        };
    },
    mounted() {
        let Isotope = require("isotope-layout");
        setTimeout(() => {
            let iso = new Isotope(".grid", {
                itemSelector: ".grid-item",
                //    layoutMode: "fitRows",
                percentPosition: true,
                masonry: {
                    columnWidth: ".grid-item",
                },
                animationOptions: {
                    duration: 750,
                    easing: "linear",
                    queue: false,
                },
            });
            let filterFns = {
                // show if number is greater than 50
                numberGreaterThan50: function (itemElem) {
                    let number = itemElem.querySelector(".number").textContent;
                    return parseInt(number, 10) > 50;
                },
                // show if name ends with -ium
                ium: function (itemElem) {
                    let name = itemElem.querySelector(".name").textContent;
                    return name.match(/ium$/);
                },
            };
            // bind filter button click filter main funtion
            let filtersElem = document.querySelector(".portfolio_filter ul");
            if (filtersElem)
                filtersElem.addEventListener("click", function (event) {
                    if (event.target.getAttribute("data-filter")) {
                        let filterValue = event.target.getAttribute("data-filter");
                        filterValue = filterFns[filterValue] || filterValue;
                        iso.arrange({ filter: filterValue });
                    }
                });
            iso.arrange({ filter: "*" });
        }, 1000);
    },
    methods: {
        // onClick(name, src) {
        //   this.name = name;
        //   this.src = src;
        //   this.modal = true;
        // },
        // closeModal() {
        //   this.modal = false;
        //   this.name = "";
        //   this.src = "";
        // },
        // close() {
        //   this.active = 0;
        // },
    },
    // components: { MagnificPopUpVue, ModalBox },
};
</script>
